import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

function FullScreenModal({
  open,
  setOpen,
  url,
}: {
  open: boolean
  setOpen: any
  url: string | undefined
}) {
  return (
    <Dialog open={open}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please <strong>return to this tab to save</strong> the data to the
          Stuart database.
        </DialogContentText>
        <Alert
          severity={'warning'}
          sx={{ mt: 1 }}
        >
          <AlertTitle>
            Forgetting to <strong>save & close</strong> on this page will
            preserve your input data in the sheet (until it expires), but will
            not save the data in Stuart
          </AlertTitle>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            window.open(
              `https://docs.google.com/spreadsheets/d/${url}/edit#gid=0?rm=minimal`,
              '_blank',
            )
            setOpen(false)
          }}
          color="success"
          disabled={!url}
        >
          Ok, Open
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FullScreenModal
